// WeightDial / handleWeightDialWheel were removed: the canvas bubble is now
// title-only read-only (per the redesign). Weight editing moved into the
// drawer's ScrollDial.

/** Pure handler extracted for testability (V1.fix5).
 * Returns a keydown listener that, when the canvas is maximized:
 * - Exits cinematic mode on Escape (if active), or
 * - Does nothing further (close-event dispatch removed by V1.fix5).
 * Non-Escape keys are ignored. */
export function makeCanvasEscapeHandler({
  isCinematicModeActive,
  setIsCinematicModeActive,
}: {
  isCinematicModeActive: boolean
  setIsCinematicModeActive: (value: boolean) => void
}): (event: KeyboardEvent) => void {
  return (event: KeyboardEvent) => {
    if (event.key !== 'Escape') return
    if (isCinematicModeActive) {
      event.preventDefault()
      setIsCinematicModeActive(false)
    }
  }
}
